<script setup lang="ts">

</script>

<template>
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.33317 19.1667C5.87484 19.1667 5.48248 19.0035 5.15609 18.6771C4.8297 18.3507 4.6665 17.9584 4.6665 17.5V2.50004C4.6665 2.04171 4.8297 1.64935 5.15609 1.32296C5.48248 0.996568 5.87484 0.833374 6.33317 0.833374H14.6665C15.1248 0.833374 15.5172 0.996568 15.8436 1.32296C16.17 1.64935 16.3332 2.04171 16.3332 2.50004V17.5C16.3332 17.9584 16.17 18.3507 15.8436 18.6771C15.5172 19.0035 15.1248 19.1667 14.6665 19.1667H6.33317ZM6.33317 15H14.6665V5.00004H6.33317V15Z" fill="#303345"/>
  </svg>
</template>

<style scoped lang="scss">

</style>